module.exports = __webpack_public_path__ + "img/product-shot_01_loading.4b373b12.jpg";